import { post } from "@/utils/request";

//favorites
export const getFavorites = (params) => post("/api/base/getFavorites", params);
export const addFavorites = (params) => post("/api/base/addFavorite", params);
export const delFavorite = (params) => post("/api/base/delFavorite", params);
export const sortFavorite = (params) => post("/api/base/sortFavorite", params);
